import type { ProductData } from "./ProductInfoCard.types";
import {
  buildSmsHref,
  normaliseAuPhoneNumber,
  normaliseAuPhoneNumberForWhatsApp,
} from "../../../lib/utils/phone";

export const formatPrice = (
  price?: number | null,
  currency: string = "AUD",
) => {
  if (price === null || price === undefined || price <= 0) {
    return "Contact for price";
  }

  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(price);
};

export const buildShareText = (name?: string, subtitle?: string) => {
  const safeName = name?.trim() || "this product";
  const safeSubtitle = subtitle?.trim();

  return safeSubtitle
    ? `Check out ${safeName} - ${safeSubtitle}`
    : `Check out ${safeName}`;
};

export const cloneProduct = (product: ProductData): ProductData =>
  JSON.parse(JSON.stringify(product || {}));

export const normaliseProduct = (product: ProductData): ProductData => ({
  id: product?.id || "",
  slug: product?.slug || "",
  title: product?.title || product?.basic?.name || "",
  basic: {
    name: product?.basic?.name || "",
    subtitle: product?.basic?.subtitle || "",
  },
  pricing: Array.isArray(product?.pricing) ? product.pricing : [],
  attributes: {
    dimensions: {
      width: product?.attributes?.dimensions?.width || "",
      height: product?.attributes?.dimensions?.height || "",
      depth: product?.attributes?.dimensions?.depth || "",
    },
  },
  features: Array.isArray(product?.features) ? product.features : [],
  description: product?.description || "",
  featureImage: {
    original: product?.featureImage?.original || "",
    thumbnail: product?.featureImage?.thumbnail || "",
    alt: product?.featureImage?.alt || "",
  },
  images: Array.isArray(product?.images) ? product.images : [],
  seo: {
    canonicalUrl: product?.seo?.canonicalUrl || "",
  },
  flags: {
    isFeatured: product?.flags?.isFeatured,
    isClearance: product?.flags?.isClearance,
    isAusMade: product?.flags?.isAusMade,
    isInStock: product?.flags?.isInStock,
  },
});


export const buildEnquiryText = (name?: string, canonicalUrl?: string, customMessage?: string) => {
  const safeName = name?.trim() || "this product";
  const message = customMessage?.trim() || `Hi, I would like to enquire about ${safeName}.`;
  const url = canonicalUrl?.trim();

  return url ? `${message} ${url}` : message;
};

export const normalisePhoneNumberForSms = (phoneNumber?: string) => {
  return normaliseAuPhoneNumber(phoneNumber);
};

export const normalisePhoneNumberForWhatsApp = (phoneNumber?: string) => {
  return normaliseAuPhoneNumberForWhatsApp(phoneNumber);
};

export const buildWhatsAppEnquiryHref = (phoneNumber?: string, message?: string) => {
  const phone = normalisePhoneNumberForWhatsApp(phoneNumber);

  if (!phone) return "";

  return `https://wa.me/${phone}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

export const buildSmsEnquiryHref = (phoneNumber?: string, message?: string) => {
  return buildSmsHref(phoneNumber, message);
};
